// extracted by mini-css-extract-plugin
export default {"icon":"__icon__KRnCs"};